// Central config sourced from env vars (swap the .env values for production).
export const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "919986616397";

export const LINKEDIN_URL =
    process.env.REACT_APP_LINKEDIN_URL || "https://www.linkedin.com/in/abhijka/";

export const INSTAGRAM_URL =
    process.env.REACT_APP_INSTAGRAM_URL || "https://www.instagram.com/abhijit.jka/";

export const CONTACT_EMAIL = process.env.REACT_APP_CONTACT_EMAIL || "info@abhijit.pro";

export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    "Hi Abhijit, I'd like to know more about your consultation and business diagnostic.",
)}`;

export const CONSULTATION_PRICE = "₹1,999";
export const CONSULTATION_TITLE = "Business Growth Roadmap Consultation";

export const DIAGNOSTIC_PRICE = "₹999";
export const DIAGNOSTIC_TITLE = "Business Diagnostic Report";

export const WORKSHOP_PRICE = "₹50,000";
export const WORKSHOP_TITLE = "2-Day Business Growth Workshop";
